import React, { useEffect, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  IconButton,
  Checkbox,
  FormControl,
  Autocomplete,
  ListSubheader,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { CiCirclePlus, CiFilter } from "react-icons/ci";
// import SearchBar from "../../SearchBar";
// import TableDownloader from "../../TableDownloader";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import FileUpload from "../../components/common/FileUpload";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  // deleteCommentEntities,
 fetchEntityById,filterEntities, postResource,} from "../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader, { BtnLoader } from "../../components/common/Loader";
// import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { useFetchTaskListsQuery, useFetchUserAccessedProjectsQuery,} from "../../slice/logdetailSlice";
import CommonDeleteDialog from "../../components/common/CommonDelete";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import SearchBar, { useDebounce } from "../../components/SearchBar";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { CommonAddTaskTab } from "../../components/common/Task/CommonAddTaskTab";
import { hasTaskPermission } from "../../utils/Permissions";
import Movetask from "../../components/common/Task/Movetask";
import { usePersistentFilter } from "../../assets/hooks/usePersistentFilter";
import CommonTaskIssueNameChamge from "../../components/common/CommonTaskIssueNameChamge";
// Theme import for styling
import { useTheme } from "../../ThemeContext";
import SubtaskBoard from "../../components/ProjectModule/task/SubtaskBoard";
import { openInNewTab } from "../../utils/openInNewTab";


const AddTaskListComponent = ({
  onApply,
  onClear,
  onCancel,
  ProjectID,
  fetchTasks,
}) => {
  const [budgetOpen, setBudgetOpen] = useState(false);
  const [ProjectOpen, setProjectOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [milestoneoption, setMilestoneoption] = useState([]);
  const projectId = localStorage.getItem("project_id");
  // const { data: user_accessed_project  , refetch : user_accessed_project_refetch} = useFetchUserAccessedProjectsQuery();
  const {
    data: user_accessed_project,
    refetch: user_accessed_project_refetch,
    isUninitialized: isUserAccessedUninitialized,
    isLoading: isUserAccessedLoading,
  } = useFetchUserAccessedProjectsQuery();

  const [selectedProject, setSelectedProject] = useState(null);

  const fetchRelatedMilestone = async () => {
    try {
      const response = await fetchEntityById(
        "fetchMilestonesByProjectDetails",
        selectedProject
      );
      ////console.log()(response, "sreetask");
      if (response?.data) {
        setMilestoneoption(response.data);
      } else {
        console.error("Invalid response data");
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  useEffect(() => {
    fetchRelatedMilestone();
  }, [selectedProject]);

  useEffect(() => {
    // Robust Triple-Guard pattern
    if (typeof user_accessed_project_refetch === "function" && !isUserAccessedUninitialized && !isUserAccessedLoading) {
      try {
        user_accessed_project_refetch();
      } catch (e) {
        console.debug("Safe refetch guard handled early call in Task.js");
      }
    }
  }, [isUserAccessedUninitialized, isUserAccessedLoading, user_accessed_project_refetch]);

  const { data: tasklist, refetch } = useFetchTaskListsQuery(selectedProject);
  ////console.log()("task_list after adding list: ", tasklist);
  const {
    handleSubmit,
    control,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      TaskName: "",
      // RelatedMilestone: "",
      project_id: null,
    },
  });

  const addMoreTasList = (e) => {
    e.preventDefault();
    handleSubmit((data) => inviteMoreTasks(data))();
  };

  const inviteMoreTasks = async (data) => {
    const requestData = {
      task_list_name: data.TaskName,
      project_id: data.project_id,
      // milestone_id: data.RelatedMilestone,
    };
    setIsSubmitting(true);
    try {
      // Call the API to create the entity
      const response = await postResource(
        "tasklist",
        "add",
        selectedProject,
        requestData
      );
      toast.success("Task List created successfully");
      reset();
      fetchTasks();
      refetch();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onSubmit = async (data) => {
    const requestData = {
      task_list_name: data.TaskName,
      project_id: data.project_id,
      // milestone_id: data.RelatedMilestone,
    };
    setIsSubmitting(true);
    try {
      // Call the API to create the entity
      const response = await postResource(
        "tasklist",
        "add",
        selectedProject,
        requestData
      );
      toast.success("Task List created successfully");
      reset();
      onCancel();
      fetchTasks();
      refetch();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex align-items-center">
            <IoIosArrowBack />
            New Task List
          </div>
        </button>
      </div>

      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="col-md-12 mb-3">
                <label htmlFor="project_id" className="form-label">
                  Project name <span className="errorMsg">*</span>
                </label>
                <Controller
                  name="project_id"
                  control={control}
                  rules={{ required: "Project field is required" }}
                  render={({
                    field: { onChange, value },
                    formState: { errors },
                  }) => (
                    <>
                      <Autocomplete
                        id="project_id"
                        options={
                          Array.isArray(user_accessed_project)
                            ? user_accessed_project
                            : []
                        }
                        getOptionLabel={(option) => option.title}
                        value={
                          user_accessed_project?.find(
                            (user) => user.project_id === value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          if (newValue) {
                            if (Array.isArray(newValue)) {
                              toast.error("You can select only one project.");
                            } else {
                              onChange(newValue.project_id);
                              setSelectedProject(newValue.project_id); // Set selected user ID
                            }
                          } else {
                            onChange(null);
                            setSelectedProject(null); // Reset selected user ID
                          }
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select project" />
                        )}
                      />
                      <span className="errorMsg">
                        {errors?.project_id?.message}
                      </span>
                    </>
                  )}
                />
              </div>

              {selectedProject && (
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="TaskName" className="form-label">
                      Task List<span className="text-rgbr-red"> *</span>
                    </label>
                    <TextField
                      id="TaskName"
                      placeholder="Enter Task Title"
                      fullWidth
                      variant="outlined"
                      {...register("TaskName", {
                        required: "Task List Title is required",
                      })} // Add validation rule here
                    />
                    {errors.TaskName && (
                      <span className="errorMsg">
                        {errors.TaskName.message}
                      </span>
                    )}
                  </div>
                </div>
              )}

              {/* <div className="col-md-12 mt-3">
                <label htmlFor="RelatedMilestone" className="form-label">
                  Related Milestone
                </label>

                <Controller
                  name="RelatedMilestone"
                  control={control}
                  defaultValue={null} // Default to null (no selection)
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={milestoneoption}
                      getOptionLabel={(option) =>
                        typeof option === "object" ? option.name : ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.milestone_id === value
                      }
                      value={
                        milestoneoption.find(
                          (c) => c.milestone_id === field.value
                        ) || null // Display label in the field
                      }
                      onChange={(_, selectedOption) => {
                        field.onChange(
                          selectedOption ? selectedOption.milestone_id : null
                        ); // Set only the ID in the field value
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  )}
                />
              </div> */}

              <div className="bg-white my-4">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="add_btn me-3"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add "
                    )}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    disabled={isSubmitting}
                    onClick={addMoreTasList}
                  >
                    {/* {isSubmitting ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add more "
                    )} */}
                    Add more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    disabled={isSubmitting}
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const Task = () => {
  const { isDarkMode } = useTheme();
  const [rows, setRows] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [checkedRows, setCheckedRows] = useState({});
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  ////console.log()("login_user in task:", login_user);
  const { role: login_user_role, id: login_user_id } = login_user;
  const [showGroupNames, setShowGroupNames] = useState("milestone");
  // const [Tasks, setTasks] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 500);
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [activeComponent, setActiveComponent] = useState("AddTask");
  const [clearFilter, setClearFilter] = useState(false);
  const [paginationModel, setPaginationModal] = useState({
    page: 0,
    pageSize: 10,
  });
  // const [filter, setFilter] = usePersistentFilter(
  //   "taskModuleFilter",
  // const [filter, setFilter] = useState(
  //   login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6
  // );
  const [filter, setFilter] = usePersistentFilter(
    "taskModuleFilter",
    1
  );
  const [loading, setLoading] = useState(false);
  const [boardLoading, setBoardLoading] = useState(false);
  // const [viewMode, setViewMode] = useState("list");
  const [viewMode, setViewMode] = usePersistentFilter("taskModuleViewMode", "list");

  const handleViewModeSwitch = (mode) => {
    if (mode === "board" && viewMode !== "board") {
      setBoardLoading(true);
      setTimeout(() => setBoardLoading(false), 700);
    }
    setViewMode(mode);
  };
  const numericTaskId = useMemo(() => {
    return selectedTask?.id
      ? parseInt(selectedTask.id.replace(/\D/g, ""), 10)
      : null;
  }, [selectedTask]);

  ////console.log()("login_user role in task:", login_user_role);
  // const { id: user_id } = useParams();
  // ////console.log()("user_id :", user_id);

  const handleCheckboxChange = (taskId) => {
    setCheckedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  // console.log("params_value_for_all :", selectedTask);
  const handleMenuOpen = (event, task) => {
    // console.log("params_value_for_all :", task);

    setMenuAnchor(event.currentTarget);
    setSelectedTask(task);
  };

  const handleShowFilter = () => setShowFilter(true);
  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedTask(null);
  };
  const handleFilterChange = (event) => {
    const value = event.target.value;
    ////console.log()("scope_filter_value", value);
    setFilter(value);
  };

  const handleShowProjects = (component) => {
    setActiveComponent(component); // Set which component to show
    setShowProject(true);
  };

  const handleMenuClick = (action, val) => {
    if (selectedTask) {
      // Extract the numeric ID from "T-11" -> 11
      const numericId =
        parseInt(selectedTask.id.replace(/\D/g, ""), 10) || selectedTask.id;

      ////console.log()(`project_id_in_task: ${selectedTask.project_id}`);
      localStorage.setItem("project_id", selectedTask.project_id);
      ////console.log()(
      // `Task ID: ${numericId}, Task Name: ${
      //   selectedTask.name || "Default Owner"
      // }`
      // );
      if (val === true) {
        ////console.log()("navigated into same page:");
        navigate(`/projects/projectDetail/${selectedTask.project_id}/taskdetail/${numericId}`);
      } else {
        ////console.log()("navigated into view  detail  page:");
        const path = `/projects/projectDetail/${selectedTask.project_id}/taskdetail/${numericId}`;
        openInNewTab(path);
      }
    }
    handleMenuClose();
  };

  const handleView = (task) => {
    const targetTask = task || selectedTask;
    if (!targetTask) return;
    const numericId =
      parseInt(String(targetTask.id).replace(/\D/g, ""), 10) || targetTask.task_id || targetTask.id;
    const newPath = `/projects/projectDetail/${targetTask.project_id}/taskdetail/${numericId}`;
    navigate(newPath, { state: { from: location.pathname } });
    handleMenuClose();
  };

  const filterOptions = {
    predefined: [
      { label: "All Tasks", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned Tasks", value: 5 },
      // { label: "Unscheduled Tasks", value: "unscheduled" },
      // { label: "Closed Task Lists", value: "closed_task_lists" },
    ],

    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      // { label: "My Overdue & Open", value: "my_overdue_open" },
      { label: "Today's Tasks", value: 8 },
      { label: "Tasks I Follow", value: 9 },
      { label: "Tasks Created By Me", value: 10 },
      // { label: "Assigned Via Pick List", value: "assigned_via_pick_list" },
    ],
  };
  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      // renderCell: (params) => (
      //   <Box display="flex" alignItems="center">
      //     {params.row.isProject || params.row.isTaskList ? (
      //       <IconButton onClick={() => toggleExpandRow(params.row.id)}>
      //         {expandedRows[params.row.id] ? (
      //           <ExpandLessIcon />
      //         ) : (
      //           <ExpandMoreIcon />
      //         )}
      //       </IconButton>
      //     ) : null}
      //     {params.row.isTask && (
      //       <>
      //         <Checkbox
      //           checked={!!checkedRows[params.row.id]}
      //           onChange={() => handleCheckboxChange(params.row.id)}
      //         />
      //         {checkedRows[params.row.id] && (
      //           <IconButton
      //             onClick={(event) => handleMenuOpen(event, params.row)}
      //           >
      //             <MoreVertIcon />
      //           </IconButton>
      //         )}
      //       </>
      //     )}
      //   </Box>
      // ),
      renderCell: (params) => {
        const row = params.row;
        const hasChildren =
          (row.isProject && row.taskLists?.length > 0) ||
          (row.isTaskList && row.tasks?.length > 0);

        return (
          <Box display="flex" alignItems="center">
            {hasChildren && (row.isProject || row.isTaskList) ? (
              <IconButton onClick={() => toggleExpandRow(row.id)}>
                {expandedRows[row.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            ) : null}

            {row.isTask && (
              <>
                <Checkbox
                  checked={!!checkedRows[row.id]}
                  onChange={() => handleCheckboxChange(row.id)}
                />
                {checkedRows[row.id] && (
                  <IconButton onClick={(event) => handleMenuOpen(event, row)}>
                    <MoreVertIcon />
                  </IconButton>
                )}
              </>
            )}
          </Box>
        );
      },
    },
    { field: "id", headerName: "ID", width: 100 },
    {
      field: "name",
      headerName: "Name",
      width: 250,
      renderCell: (params) => {
        // const navigate = useNavigate(); // Hook for navigation

        const handleClick = () => {
          if (!params.row.isProject && !params.row.isTaskList) {
            const numericId = params.row.id.replace(/\D/g, ""); // Extract number from ID
            navigate(`/projects/projectDetail/${params.row.project_id}/taskdetail/${numericId}`);
          }
        };

        return (
          <Box
            sx={{
              fontWeight: params.row.isProject
                ? 600
                : params.row.isTaskList
                  ? 500
                  : "normal",
              cursor:
                !params.row.isProject && !params.row.isTaskList
                  ? "pointer"
                  : "default",
            }}
            onClick={handleClick}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: "owner",
      headerName: "Owner",
      width: 200,
      renderCell: (params) => {
        const owners = params.row.owners || [];
        const displayValue = params.value;

        // const tooltipTitle = owners.length > 0 ? (
         if (owners.length > 0) {
        const tooltipTitle = (
          <Box>
            {owners.map((o, index) => (
              <div key={index}>{o.name}</div>
            ))}
          </Box>
        // ) : "Unassigned";
        );

        return (
            <Tooltip title={tooltipTitle} arrow>
              <Box sx={{ cursor: "pointer" }}>{displayValue}</Box>
            </Tooltip>
        );
        }

        return <Box>{displayValue}</Box>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const color = params.row.status_colour;
        const name = params.value;
        return <p style={{ color: color }}>{name}</p>;
      },
    },
    {
      field: "priority",
      headerName: "Priority",
      width: 120,
      renderCell: (params) => {
        const color = params.row.priority_colour;
        const name = params.value;
        return <p style={{ color: color }}>{name}</p>;
      },
    },
    { field: "startDate", headerName: "Start Date", width: 150 },
    { field: "dueDate", headerName: "Due Date", width: 150 },
    { field: "duration", headerName: "Duration", width: 150 },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      width: 150,
      renderCell: (params) => {
        if (!params.row.isTask) return null;
        return <Box>{params.value !== undefined && params.value !== null ? `${params.value}%` : "0%"}</Box>;
      },
    },
    {
      field: "billing_type",
      headerName: "Billable Type",
      width: 150,
      renderCell: (params) => {
        if (!params.row.isTask) return null;
        return (
          <Box>
            {params.value || "N/A"}
          </Box>
        );
      },
    },
    {
      field: "added_by_name",
      headerName: "Created By",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isTask) return null;
        return <Box>{params.value || "N/A"}</Box>;
      },
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isTask || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isTask) return null;
        return <Box>{params.value || "N/A"}</Box>;
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isTask || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
  ];

  const fetchTaskModule = async () => {
    setLoading(true);
    const requestedData = {
      view_type_id: filter,
    };
    try {
      const response = await filterEntities("tasks/show/all", requestedData);
      if (response?.data) {
        setRows(transformResponse(response.data));
        ////console.log()("response_data: ", response.data);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaskModule();
  }, [filter]);
  const toggleExpandRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle expansion for the clicked row
    }));
  };

  const fetchSearchedTask = async (searchQuery) => {
    setLoading(true);
    try {
      const response = await filterEntities("tasks/show/all", {
        searchText: searchQuery,
        view_type_id: filter,
      });

      ////console.log()("task_search_response:", response.data);

      if (response?.data) {
        const transformedData = transformResponse(response?.data, true); // Pass `true` for search
        ////console.log()("Transformed Searched Data:", transformedData);
        setRows(transformedData);
      } else {
        setRows([]);
      }
    } catch (error) {
      console.error("Failed to fetch tasks:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearch) {
      fetchSearchedTask(debouncedSearch);
    } else {
      fetchTaskModule();
    }
  }, [debouncedSearch]);
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);

  };
  const getFlattenedRows = () => {
    const flattenedRows = [];

    rows.forEach((project) => {
      flattenedRows.push(project);

      if (expandedRows[project.id] && project.taskLists) {
        project.taskLists.forEach((taskList) => {
          flattenedRows.push(taskList);

          if (expandedRows[taskList.id] && taskList.tasks) {
            taskList.tasks.forEach((task) => flattenedRows.push(task));
          }
        });
      }
    });

    return flattenedRows;
  };

  const transformResponse = (data) => {
    if (!Array.isArray(data)) return [];

    return data.map(({ project, task_lists }) => {
      const projectRow = {
        id: `P-ID${project.project_id}`,
        name: project.title,
        owner: project.owner_name || "N/A",
        status: project.current_status_name || "N/A",
        status_colour: project.current_status_colour || " ",
        priority_colour: project.status_priority_colour || " ",

        isProject: true,
        taskLists: task_lists.map(({ task_list, tasks }) => {
          const taskListRow = {
            id: `TL-ID${task_list.task_list_id}`,
            name: task_list.task_list_name,
            owner: task_list.owner_name || "N/A",
            // owner: "N/A", // Task lists don't have owners in this response
            startDate: task_list.added_at
              ? new Date(task_list.added_at).toLocaleDateString()
              : "N/A",
            isTaskList: true,
            parentId: `P-ID${project.project_id}`,
            tasks: (tasks || []).map((task) => {
              const owners = task.owners || [];
              const ownerDisplay =
                owners.length > 0
                  ? `${owners[0].name}${owners.length > 1 ? ` (+${owners.length - 1})` : ""
                  }`
                  : "N/A";

              return {
                id: `T-${task.task_id}`,
                task_id: task.task_id,
                name: task.title,
                title: task.title,
                owner: ownerDisplay, // Display first owner and count
                owners: task.owners,
                status: task.current_status_name || "N/A",
                current_status_name: task.current_status_name || "N/A",
                current_status_id: task.current_status_id,
                startDate: task.start_date
                  ? new Date(task.start_date).toLocaleDateString()
                  : "N/A",
                dueDate: task.end_date
                  ? new Date(task.end_date).toLocaleDateString()
                  : "N/A",
                duration: task.estimated_hours
                  ? `${task.estimated_hours} hrs`
                  : "N/A",
                priority: task.priority_name || "Low",
                priority_name: task.priority_name || "Low",
                owners: task.owners,
                added_by: task.added_by,
                added_by_name: task.added_by_name,
                updated_name: task.updated_name,
                status_colour: task.status_colour,
                log_hours: task.log_hours,
                priority_colour: task.priority_colour,
                start_date: task.start_date,
                end_date: task.end_date,
                isTask: true,
                parentId: `TL-ID${task_list.task_list_id}`,
                project_id: project.project_id,
                project_title: project.title,
                task_list_name: task_list.task_list_name,
                added_at: task.added_at || null,
                updated_at: task.updated_at || null,
                billing_type: task.billing_type || null,
                completed_percentage: task.completed_percentage,
              };
            }),
          };
          return taskListRow;
        }),
      };
      return projectRow;
    });
  };

  const handleCloseProject = () => setShowProject(false);
  // const deactivateUser = async () => {
  //   const response = await deleteCommentEntities("user/deactivate", user_id);
  //   // name user
  //   // refetch fetchTasks
  // };
  const canEditTask = hasTaskPermission(
    selectedTask,
    login_user_id,
    login_user_role
  );


  return (
    <>
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          {activeComponent === "AddTask" && (
            // <AddTaskComponent
            // onCancel={handleCloseProject}
            // ProjectID={ProjectID}
            // fetchTasks={fetchTaskModule}
            //   // onApply={handleAddTask}
            // />
            <CommonAddTaskTab
              onCancel={handleCloseProject}
              // ProjectID={ProjectID}
              refetchList={fetchTaskModule}
              isModule={true}
              path_1="task"
              path_2="add"
            />
          )}
          {activeComponent === "AddTaskList" && (
            <AddTaskListComponent
              onCancel={handleCloseProject}
              // ProjectID={ProjectID}
              fetchTasks={fetchTaskModule}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>
      <div style={{ height: "100%", width: "100%" }} className="bg-white p-3">
        {/* <div className="d-flex justify-content-between pb-2"> */}
        <Box
          className="d-flex justify-content-between"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex gap-3  align-items-center">
            <FormControl className="mt-1">
              <Select value={filter} onChange={handleFilterChange} displayEmpty>
                <ListSubheader className="ps-3 text-rgba-gray">
                  Predefined Views
                </ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}

                <ListSubheader className="ps-3 text-rgba-gray">
                  My Views
                </ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div
              className="d-flex align-items-center mt-1"
              style={{ gap: "4px", alignSelf: "center" }}
            >
              <Tooltip title="Table View">
                <IconButton
                  onClick={() => handleViewModeSwitch("list")}
                  sx={{
                    backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: '10px',
                    "&:hover": {
                      backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <CiViewList size={18} />
                  Table
                </IconButton>
              </Tooltip>

              <Tooltip title="Board View">
                <IconButton
                  onClick={() => handleViewModeSwitch("board")}
                  sx={{
                    backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <MdViewQuilt size={18} />
                  Board
                </IconButton>
              </Tooltip>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <SearchBar
              placeholder="Search tasks"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {/* <button
              className='border-0 p-2 rounded-circle text-decoration-none me-4 ms-4 project-icon-bg'
              onClick={handleShowProject}
              >
              <CiCirclePlus className='text-rgbr-blue pro-icon-s' />
              </button> */}
            {clearFilter && (
              <button
                type="button"
                disabled={loading}
                className="addmore_btn me-3"
                onClick={fetchTaskModule}
              >
                Clear filter
              </button>
            )}

            {/* {login_user_role !== "CLIENT" && ( */}
            <ButtonGroup className="me-3 ms-2">
              <Button
                onClick={() => handleShowProjects("AddTask")}
                className="rounded-0 rounded-start AddButton"
              >
                Add Task
              </Button>
              
              <Dropdown>
                <Dropdown.Toggle
                  split
                  className="rounded-0 rounded-end AddButton py-2"
                  id="dropdown-split-button"
                />
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => handleShowProjects("AddTaskList")}
                  >
                    Add Task List
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ButtonGroup>
            {/* )} */}

            {/* <button
              className="border-0 p-2 rounded-circle text-decoration-none me-3 project-icon-bg"
              onClick={handleShowFilter}
            >
              <CiFilter className="text-rgbr-blue pro-icon-s" />
            </button> */}
          </div>
        {/* </div> */}
      </Box>

        {loading ? (
          <Loader />
        ) : (
          <Box
            style={{
              height: rows.length === 0 ? 300 : "100%",
              width: "100%",
            }}
          >
            {viewMode === "list" ? (
              <DataGrid
                rows={getFlattenedRows()}
                columns={columns}
                // getRowId={(row) => row.id}
                loading={loading}
                pagination
                // disableColumnMenu
                // disableColumnSorting
                // disableColumnFilter
                // disableColumnSelector
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModal}
                pageSizeOptions={[10, 20, 30, 40]}
                getRowId={(row) => row.id}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                autoHeight
              />
            ) : (
              <>
                {boardLoading && <Loader />}
                <SubtaskBoard
                allTasks={rows.flatMap((p) =>
                  (p.taskLists || []).flatMap((tl) => tl.tasks || [])
                )}
                onRefresh={fetchTaskModule}
                loading={loading}
                searchTerm={debouncedSearch}
                onOpenTask={(task) => {
                  handleView(task);
                }}
              />
              </>
            )}
          </Box>
        )}
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={() => handleMenuClick("View Details", true)}>
            <CiViewList className="me-2" color="blue" />
            View Details
          </MenuItem>
          <MenuItem
            onClick={() => handleMenuClick("View Details in New Tab", false)}
          >
            <CiViewList className="me-2" color="blue" />
            View Details in New Tab
          </MenuItem>

          {canEditTask && (
            <>
              <CommonDeleteDialog
                name="Task"
                refetchList={fetchTaskModule}
                handleListClose={handleMenuClose}
                url="task/delete"
                id={numericTaskId}
                statusName={selectedTask?.name}
                logHours={selectedTask?.log_hours}
              // statusName={rows.find((task)=>task.task_id === selectedTask)?}
              />
              <Movetask
                handleMenuClose={handleMenuClose}
                login_user_id={login_user_id}
                selectedTask={selectedTask}
                path="task/moveTask"
                project_id={selectedTask?.project_id}
                refetch_list={fetchTaskModule}
              />
              <CommonTaskIssueNameChamge
                name="Task"
                path="task/update"
                selectedTask={selectedTask}
                setMenuAnchorEl={setMenuAnchor}
                refetch_list={fetchTaskModule}
                isModule={true}
              />
            </>
          )}
        </Menu>
      </div>
    </>
  );
};
export default Task;
